import { Component, OnInit, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiDataService, IApiResultObject } from './services/api-data.service';

interface IPageRatingModel {
    ratingValue: number | null,
    ratingCount: number | null
}

@Component({
    selector: 'app-rating',
    template: require('./app.component.rating.html'),
    styles: [require('./app.component.rating.css')],
    providers: [ApiDataService]
})
export class RatingComponent implements OnInit {

    private culture: string = 'uk';
    private link: string = '';
    
    private init: IApiResultObject = null;
    private ratingModel: IPageRatingModel = null;
    

    constructor(private translate: TranslateService, private apiDataService: ApiDataService, private elementRef: ElementRef) {
        this.culture = this.elementRef.nativeElement.getAttribute('culture');
        this.link = this.elementRef.nativeElement.getAttribute('path');
        translate.setDefaultLang(this.culture);

        this.init = {} as IApiResultObject;
        this.init.data = [];
    }

    ngOnInit() {
        this.GetRatingModel();
    }

    GetRatingModel(): void {
        this.apiDataService.Get(`/${this.culture}/Evaluation/GetPageRankByLink?link=${this.link}`)
            .subscribe(d => {
                this.init = d as IApiResultObject;
                if (this.init.status) {
                    this.ratingModel = this.init.data;
                }
            });
    }

    get percent(): number {
        if (this.ratingModel == null)
            return 100;
        return (this.ratingModel.ratingValue / 5) * 100;
    }

    get gradient(): string {
        return `linear-gradient(90deg, #FFd500 ${this.percent}%, rgba(0,0,0,0.2) ${this.percent}%)`;
    }
}